<template>
  <b-row
    v-if="forcerow"
    @mouseover="onHover"
    @mouseleave="onLeave"
    @click="select()"
  >
    <b-col :class="{'m-0 p-0':compact}">
      <p
        class="mb-0 label-input-text"
      >
        {{ controller.text }}:
      </p>
    </b-col>
    <b-col :class="{'m-0 p-0':compact}">
      <b-form-input
        v-model="inputValue"
        :state="controller.condition(inputValue)"
        aria-describedby="input-live-help input-live-feedback"
        :placeholder="controller.placeholder"
        trim
        :size="sizeinput"
        :disabled="disabled"
      />
      <b-form-invalid-feedback class="input-live-feedback">
        {{ controller.feedback }}
      </b-form-invalid-feedback>
    </b-col>
  </b-row>
  <div
    v-else
    @mouseover="onHover"
    @mouseleave="onLeave"
    @click="select()"
  >
    <p
      class="mb-0 label-input label-input-text"
    >
      {{ controller.text }}:
    </p>
    <b-form-input
      v-model="inputValue"
      :state="controller.condition(inputValue)"
      aria-describedby="input-live-help input-live-feedback"
      :placeholder="controller.placeholder"
      trim
      :size="sizeinput"
      :disabled="disabled"
    />
    <b-form-invalid-feedback class="input-live-feedback">
      {{ controller.feedback }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TextInputConfiguration',
  props: {
    controller:{
      type:Object,
      required: true
    },
    sizeinput:{
      type: String,
      required:false,
      default: ''
    },
    forcerow:{
      type:Boolean,
      required: false,
      default: false
    },
    eventonchange:{
      type:Boolean,
      required: false,
      default: false
    },
    compact:{
      type:Boolean,
      required: false,
      default: false
    },
    disabled:{
      type:Boolean,
      required:false,
      default: false
    }
  },
  computed: { 
    inputValue: {
      set (value) {
        this.controller.setValue(value)
        if(this.eventonchange){
          this.$emit('onChange')
        }
      },
      get () {
        return this.controller.value
      }
    },
   },
   methods: { 
    ...mapActions(['setContextOnHover','setContextFixElement']),
    onHover() {
      if(this.controller.contextHelp!==null){
        this.setContextOnHover(this.controller.contextHelp)
      }
    },
    onLeave(){
      if(this.controller.contextHelp!==null){
        this.setContextOnHover(null)
      }
    },
    select(){
      if(this.controller.contextHelp!==null){
        this.setContextFixElement(this.controller.contextHelp)
      }
    }
  }
}
</script>

<style scoped>
.label-input{
  margin: 0;
}
</style>